import React, { useState, useEffect } from 'react';
import { createSite, fetchUserSites } from '../../services/sites';
import Site from './Site';
import { Modal } from '../Common/Modal';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
const Sites = ({ editEnabled }) => {
  const { theme } = useTheme();
  const { canCreateSite } = useAuth();
  const [sites, setSites] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [createForm, setCreateForm] = useState({
    name: '',
    siteKey: '',
    siteSecret: ''
  });

  const loadSites = async () => {
    try {
      const response = await fetchUserSites(false);
      setSites(response);
    } catch (error) {
      console.error('Error loading sites:', error);
    }
  };

  useEffect(() => {
    loadSites();
  }, []);

  const handleCreate = async () => {
    try {
      await createSite(
        createForm.name,
        createForm.siteKey,
        createForm.siteSecret
      );
      setIsCreating(false);
      setCreateForm({
        name: '',
        siteKey: '',
        siteSecret: ''
      });
      loadSites();
    } catch (error) {
      console.error('Error creating site:', error);
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] p-2 md:p-4 space-y-2 md:space-y-4 w-[calc(100vw-64px)]">
      {canCreateSite && (
        <div className="flex justify-between items-center">
          <h2 className={`text-2xl font-bold ${theme === 'light' ? 'text-gray-900' : 'text-gray-100'}`}>Sites</h2>
          <button
            onClick={() => setIsCreating(true)}
            className="px-2.5 py-1 text-xs font-medium border backdrop-blur-sm rounded-full transition-all duration-200 flex items-center gap-1 whitespace-nowrap border-purple-500/30 text-purple-500 bg-purple-500/10 hover:bg-purple-500/20"
          >
            Create New Site
          </button>
        </div>
      )}

      <div className={`flex-1 overflow-auto border rounded-lg ${
        theme === 'light' ? 'border-gray-200' : 'border-gray-700'
      }`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
          {sites.map((site) => (
            <Site
              key={site.id}
              site={site}
              onDelete={loadSites}
              onUpdate={loadSites}
              userRole={site.role}
              userId={site.user_id}
              editEnabled={editEnabled}
            />
          ))}
        </div>
      </div>

      <Modal
        isOpen={isCreating}
        onClose={() => setIsCreating(false)}
        title="Create New Site"
      >
        <div className="space-y-4">
          <input
            type="text"
            value={createForm.name}
            onChange={(e) => setCreateForm({...createForm, name: e.target.value})}
            className={`w-full px-2 md:px-3 py-2 rounded-lg border outline-none ${
              theme === 'light' 
                ? 'border-gray-300 bg-white text-gray-900' 
                : 'border-gray-700 bg-gray-800 text-gray-100'
            }`}
            placeholder="Site Name"
          />
          <input
            type="text"
            value={createForm.siteKey}
            onChange={(e) => setCreateForm({...createForm, siteKey: e.target.value})}
            className={`w-full px-2 md:px-3 py-2 rounded-lg border outline-none ${
              theme === 'light' 
                ? 'border-gray-300 bg-white text-gray-900' 
                : 'border-gray-700 bg-gray-800 text-gray-100'
            }`}
            placeholder="Site Key"
          />
          <input
            type="text"
            value={createForm.siteSecret}
            onChange={(e) => setCreateForm({...createForm, siteSecret: e.target.value})}
            className={`w-full px-2 md:px-3 py-2 rounded-lg border outline-none ${
              theme === 'light' 
                ? 'border-gray-300 bg-white text-gray-900' 
                : 'border-gray-700 bg-gray-800 text-gray-100'
            }`}
            placeholder="Site Secret"
          />
          <button
            onClick={handleCreate}
            className="w-full px-2.5 py-1 text-xs font-medium border backdrop-blur-sm rounded-full transition-all duration-200 flex items-center justify-center gap-1 whitespace-nowrap border-purple-500/30 text-purple-500 bg-purple-500/10 hover:bg-purple-500/20"
          >
            Create Site
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Sites;
